import { supabase } from '@/lib/supabase';

export type AdminRole = 'dev_admin' | 'super_admin' | 'admin' | 'member';

const STAFF_ROLES: AdminRole[] = ['dev_admin', 'super_admin', 'admin'];

export function resolveAdminRole(raw: string | null | undefined): AdminRole {
  if (raw === 'dev_admin' || raw === 'super_admin' || raw === 'admin') return raw;
  return 'member';
}

export function isStaffRole(role: AdminRole): boolean {
  return STAFF_ROLES.includes(role);
}

/** 角色对应控制台首页路径 */
export function consolePathForRole(role: AdminRole): string {
  switch (role) {
    case 'dev_admin':
      return '/admin/reliability';
    case 'super_admin':
      return '/admin/business';
    case 'admin':
      return '/admin/support';
    default:
      return '/';
  }
}

export function consoleLabelForRole(role: AdminRole): string {
  switch (role) {
    case 'dev_admin':
      return '平台稳定控制台';
    case 'super_admin':
      return '商业营运控制台';
    case 'admin':
      return '会员支持控制台';
    default:
      return '';
  }
}

/** 角色来源：get_admin_role() RPC，不使用 super_admins 旧模型 */
export async function getAdminRole(): Promise<AdminRole> {
  const { data, error } = await supabase.rpc('get_admin_role');
  if (error) return 'member';
  return resolveAdminRole(data as string | null);
}
